import React from 'react';
import Smile_A from '../../components/smileImg/smile1.png';
import Smile_B from '../../components/smileImg/smile2.png';
import Smile_C from '../../components/smileImg/smile3.png';
import Smile_D from '../../components/smileImg/smile4.png';
import Smile_E from '../../components/smileImg/smile5.png';
import Smile_F from '../../components/smileImg/smile6.png';
import Smile_G from '../../components/smileImg/smile7.png';


const arrayEmojis = [
    {
        'img': Smile_A,
        'name': ':smiley:'
    },
    {
        'img': Smile_B,
        'name': ':sad:'
    },
    {
        'img': Smile_C,
        'name': ':wink:'
    },
    {
        'img': Smile_D,
        'name': ':angry:'
    },
    {
        'img': Smile_E,
        'name': ':oh:'
    },
    {
        'img': Smile_F,
        'name': ':like:'
    },
    {
        'img': Smile_G,
        'name': ':unlike:'
    }
];

export default function Emoji(p) {
    return (
        <ul className="sm-emoji zoomIn animated">
            {arrayEmojis.map((emoji, i) => {
                return (<li key={i} onClick={() => p.handleChangeEmoji(emoji)}>
                <img src={emoji.img} style={{width: '25px'}} alt={emoji.name} />
            </li>)}
            )}
        </ul>
    )
}


// WEBPACK FOOTER //
// ./src/components/Emoji/index.js